/**
 * LabelToggleButton (UI-SPEC W3) — toggle pin number-labels visibility.
 *
 * Per-user persisted via `localStorage('storm-pin-labels')`. Default ON
 * if the key is absent. The button itself is symmetric (Hash icon) so no
 * RTL mirror is needed.
 */
import { Hash } from "lucide-react";
import { useIntl } from "react-intl";

interface LabelToggleButtonProps {
  visible: boolean;
  onToggle: () => void;
}

export function LabelToggleButton({ visible, onToggle }: LabelToggleButtonProps) {
  const intl = useIntl();
  const ariaLabel = intl.formatMessage({
    id: visible ? "LABEL_NUMBER_LABELS_ON" : "LABEL_NUMBER_LABELS_OFF",
  });
  return (
    <button
      type="button"
      aria-pressed={visible}
      aria-label={ariaLabel}
      onClick={onToggle}
      data-testid="label-toggle-button"
      className={`h-9 w-9 rounded-md focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 inline-flex items-center justify-center transition-colors duration-200 ${
        visible
          ? "bg-secondary-container text-on-secondary-container"
          : "bg-surface-raised text-on-surface ring-1 ring-divider"
      }`}
    >
      <Hash size={18} aria-hidden="true" />
    </button>
  );
}
